module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "createSuccess"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "success"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": _vm.item[_vm.state].src
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "msg"
  }, [_vm._v(_vm._s(_vm.item[_vm.state].name))]), _vm._v(" "), _c('p', {
    staticClass: "msg2"
  }, [_vm._v(_vm._s(_vm.item[_vm.state].desc))]), _vm._v(" "), _c('div', {
    staticClass: "tip-header"
  }, [_vm._v("说明")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("1、参保人须为商户经营者或法定代表人，和营业执照保持一致；")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("2、提交的商户信息均需为有效信息；")])]), _vm._v(" "), (_vm.state == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.edit()
      }
    }
  }, [_vm._v("修改参保信息")]) : _vm._e(), _vm._v(" "), (_vm.state == 2) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.toindex()
      }
    }
  }, [_vm._v("查看我的保单")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f610bf16"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/createSuccess.vue
// module id = 849
// module chunks = 1